import {connect} from "react-redux"
import {ENTRYPOINT_HEADER_NAME} from "../../config/constants"
import State from "../../ducks/state"
import {SupportedRegionTypes} from "../../models/regions"
import {shouldDisplayBackToSiteBanner} from "../../utils/backToSiteBanner"

export const mapStateToProps = (state: State) => {
    const {regions} = state.data || {}
    const {backToSiteBannerConfiguration, backToNextBannerShowAlways} = state.settings
    const entrypointHeader = state.request.headers?.[ENTRYPOINT_HEADER_NAME]

    const banner = regions?.find(region => region.type === SupportedRegionTypes.BackToSiteBanner)?.elements[0] || null
    const displayBanner = shouldDisplayBackToSiteBanner(
        regions,
        backToSiteBannerConfiguration,
        entrypointHeader,
        backToNextBannerShowAlways,
    )

    return {
        banner,
        displayBanner,
    }
}

export default connect(mapStateToProps)
